import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import { motion } from 'framer-motion';
import Button from '../ui/Button';

const Hero = () => {
    const { t } = useLanguage();
    return (
        <section className="relative h-screen flex items-center justify-center overflow-hidden bg-slate-900 text-white">
            {/* Background Overlay */}
            <div className="absolute inset-0 z-0 opacity-40 bg-[url('https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center bg-no-repeat bg-fixed" />
            <div className="absolute inset-0 z-0 bg-gradient-to-b from-slate-900/80 via-slate-900/50 to-slate-900" />

            <div className="container mx-auto px-4 z-10 text-center">
                {/* <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-3xl md:text-5xl font-bold mb-4 tracking-tight"
                >
                </motion.h1> */}

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="mb-8"
                >
                    <span className="text-5xl md:text-7xl font-extrabold text-gold-500 block mb-2 drop-shadow-lg">{t.hero.title}</span>
                    {/* Assuming logic for NOVI PAZAR or similar if explicitly needed, but using subtitle from translations if available or keeping static if not in data */}
                    <span className="text-2xl md:text-3xl font-light tracking-widest text-slate-200">NOVI PAZAR</span>
                </motion.div>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="text-xl md:text-2xl text-slate-300 mb-10 max-w-2xl mx-auto whitespace-pre-line"
                >
                    {t.hero.description}
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="flex flex-col md:flex-row gap-4 justify-center"
                >
                    <Button variant="primary" onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })}>
                        {t.hero.viewProjects}
                    </Button>
                    <Button variant="secondary" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
                        {t.hero.contactUs}
                    </Button>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
